import * as Immutable from "immutable";
import SharedEntity from "logic/permissions/SharedEntity";
import ApiRoutes from "routing/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
import EntityShareState from "logic/permissions/EntityShareState";
import { qualifyUrl } from "util/URLUtils";
import PaginationURL from "util/PaginationURL";
const DEFAULT_PREPARE_PAYLOAD = {};
const formatPaginatedSharesResponse = ({
  additional_queries: additionalQueries,
  context,
  count,
  entities,
  page,
  per_page: perPage,
  query,
  total
}) => ({
  list: Immutable.List(entities.map((se) => SharedEntity.fromJSON(se))),
  context: {
    granteeCapabilities: context.grantee_capabilities
  },
  pagination: {
    additionalQueries,
    page,
    perPage,
    query,
    count,
    total
  }
});
export const prepareEntityShare = (entityGRN, payload = DEFAULT_PREPARE_PAYLOAD) => {
  const url = entityGRN ? ApiRoutes.EntityShareController.prepare(entityGRN).url : ApiRoutes.EntityShareController.prepareEntityCreate().url;
  return fetch("POST", qualifyUrl(url), JSON.stringify(payload)).then(
    (response) => EntityShareState.fromJSON(response)
  );
};
export const updateEntityShare = (entityGRN, payload) => {
  const url = qualifyUrl(ApiRoutes.EntityShareController.update(entityGRN).url);
  return fetch("POST", url, JSON.stringify(payload)).then(
    (response) => EntityShareState.fromJSON(response)
  );
};
export const loadUserSharesPaginated = (userId, pagination) => {
  const { page, perPage, query, additionalQueries } = pagination;
  const url = PaginationURL(
    ApiRoutes.EntityShareController.userSharesPaginated(userId).url,
    page,
    perPage,
    query,
    additionalQueries
  );
  return fetch("GET", qualifyUrl(url)).then(formatPaginatedSharesResponse);
};
